import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsTransactionSchema = withDefaults({
  type: 'pcs-transaction',
  fields: [
    {
      kind: 'attribute',
      name: 'provider',
    },
    {
      kind: 'attribute',
      name: 'providerId',
    },
    {
      kind: 'attribute',
      name: 'providerData',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'pcsCard',
      type: 'pcs-card',
      options: {
        async: false,
        inverse: 'pcsTransactions',
      },
    },
    {
      kind: 'belongsTo',
      name: 'pcsAuthorization',
      type: 'pcs-authorization',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default PcsTransactionSchema;
